const CountriesDataChart = () => {
    function _getData(countries, extra){
        const c = extra ? countries.concat(extra) : countries
        return {
            labels: c.map(a=>a.name),
            datasets: [{
                label: 'Members by Country',
                data: c.map(a=>a.members),
                backgroundColor: [
                    'rgba(255, 99, 132, 0.2)',
                    'rgba(54, 162, 235, 0.2)',
                    'rgba(255, 206, 86, 0.2)',
                    'rgba(75, 192, 192, 0.2)',
                    'rgba(153, 102, 255, 0.2)',
                    'rgba(255, 159, 64, 0.2)'
                ],
                borderColor: [
                    'rgba(255, 99, 132, 1)',
                    'rgba(54, 162, 235, 1)',
                    'rgba(255, 206, 86, 1)',
                    'rgba(75, 192, 192, 1)',
                    'rgba(153, 102, 255, 1)',
                    'rgba(255, 159, 64, 1)'
                ],
                borderWidth: 1
            }]
        }
    }

    //return: data={label:[], datasets:[]}
    function _getChartData(countries, maxNumber) {
        const condensed = countries.slice(0, maxNumber - 1)

        let members = 0
        for (let i = maxNumber - 1; i < countries.length; ++i) {
            members += countries[i].members
        }
        return _getData(condensed,countries.length <= maxNumber ? null : [{ name: 'Others', members }])
    }

    return {
        getChartData: _getChartData
    }
}

export default CountriesDataChart()
